var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNftDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15527",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15527",
    transform: "translate(-11362 -20936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u591A\\u89D2\\u5F62_125",
    "data-name": "\\u591A\\u89D2\\u5F62 125",
    d: "M30.691,0a10,10,0,0,1,8.65,4.983l6.35,10.949a10,10,0,0,1,0,10.034l-6.35,10.949a10,10,0,0,1-8.65,4.983H17.911a10,10,0,0,1-8.65-4.983L2.91,25.966a10,10,0,0,1,0-10.034L9.26,4.983A10,10,0,0,1,17.911,0Z",
    transform: "translate(11411.898 20940) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9548",
    "data-name": "\\u9577\\u65B9\\u5F62 9548",
    width: 57,
    height: 57,
    transform: "translate(11362 20936)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftDetail);
export default __webpack_public_path__ + "static/media/nftDetail.a8260d763de3b762b1cb080ed18ca350.svg";
export { ForwardRef as ReactComponent };